import {DatabaseCode, toDatabaseCode} from "./database-code";

export type SystemProcessDomain = DatabaseCode;

const dataIngest: SystemProcessDomain = {
  code: "DATA_INGEST",
  displayValue: {
    id: "common.entity.systemprocessdomain.dataIngest",
    defaultMessage: "Data Ingest",
  },
};

const masterData: SystemProcessDomain = {
  code: "MASTER_DATA",
  displayValue: {
    id: "common.entity.systemprocessdomain.masterData",
    defaultMessage: "Master Data",
  },
};

const outbound: SystemProcessDomain = {
  code: "OUTBOUND",
  displayValue: {
    id: "common.entity.systemprocessdomain.outbound",
    defaultMessage: "Outbound",
  },
};

const internal: SystemProcessDomain = {
  code: "INTERNAL",
  displayValue: {
    id: "common.entity.systemprocessdomain.internal",
    defaultMessage: "Internal",
  },
};

const internalBatch: SystemProcessDomain = {
  code: "INTERNAL_BATCH",
  displayValue: {
    id: "common.entity.systemprocessdomain.internalBatch",
    defaultMessage: "Internal Batch",
  },
};

const notification: SystemProcessDomain = {
  code: "NOTIFICATION",
  displayValue: {
    id: "common.entity.systemprocessdomain.notification",
    defaultMessage: "Notification",
  },
};

export const systemProcessDomain = {
  dataIngest,
  masterData,
  outbound,
  internalBatch,
  notification,
};

export const systemProcessDomains = Object.values(systemProcessDomain);

export const toSystemProcessDomain = (code: string): SystemProcessDomain =>
  toDatabaseCode(code, systemProcessDomains);

export const toSystemProcessDomainSafely = (
  code: string | undefined
): SystemProcessDomain | undefined =>
  code ? toDatabaseCode(code, systemProcessDomains) : undefined;
